import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import React, { CSSProperties } from "react";

interface IRichTextEditorProps {
  value: string;
  setValue: (value: string) => void;
  style: CSSProperties;
  theme?: string;
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "align",
  "list",
  "bullet",
  "link",
];

const RichTextEditor: React.FC<IRichTextEditorProps> = ({ value, setValue, style, theme }) => {
  return (
    <ReactQuill
      theme={theme ? theme : "snow"}
      value={value}
      onChange={setValue}
      style={style}
      modules={modules}
      formats={formats}
    />
  );
};

export default RichTextEditor;
